import { BusinessStatus, OnboardingStatus } from '@Store/slices/customer/customer.types.ts';

export interface KybData {
  success?: boolean;
  onboardingStatus?: OnboardingStatus;
  business: {
    externalId: string;
    name: string;
    naicsIndustry: string;
    businessType: string;
    status: BusinessStatus;
    missingLlcDocuments: (keyof typeof BUSINESS_FILE_TYPES)[];
    primaryOwnershipPercent: number;
  };
}
export enum BUSINESS_FILE_TYPES {
  IRS_EIN_LETTER = 'IRS_EIN_LETTER',
  ARTICLES_OF_ORGANIZATION = 'ARTICLES_OF_ORGANIZATION',
  ARTICLES_OF_INCORPORATION = 'ARTICLES_OF_INCORPORATION',
  LETTER_OF_REINSTATEMENT = 'LETTER_OF_REINSTATEMENT',
  GOVERNMENT_IDENTIFICATION = 'GOVERNMENT_IDENTIFICATION',
  SIGNED_PARTNERSHIP_AGREEMENT = 'SIGNED_PARTNERSHIP_AGREEMENT',
}

export interface IKybSlice {
  kybData: KybData;
  setKybData: (data: KybData) => void;
  getKybData: () => KybData;
}

export const businessFileTypesImages = {
  IRS_EIN_LETTER: [
    'https://assets.lili.co/onboarding/verification_center/IRS_EIN_LETTER_A.png',
    'https://assets.lili.co/onboarding/verification_center/IRS_EIN_LETTER_B.png',
    'https://assets.lili.co/onboarding/verification_center/IRS_EIN_LETTER_C.png',
  ],
  ARTICLES_OF_ORGANIZATION: [
    'https://assets.lili.co/onboarding/verification_center/ARTICLES_OF_ORGANIZATION_MULTI.png',
    'https://assets.lili.co/onboarding/verification_center/ARTICLES_OF_ORGANIZATION_SINGLE.png',
  ],
  ARTICLES_OF_INCORPORATION: [
    'https://assets.lili.co/onboarding/verification_center/ARTICLES_OF_INCORPORATION_MULTI.png',
    'https://assets.lili.co/onboarding/verification_center/ARTICLES_OF_INCORPORATION_SINGLE.png',
  ],
  LETTER_OF_REINSTATEMENT: [
    'https://assets.lili.co/onboarding/verification_center/LETTER_OF_REINSTATEMENT.png',
  ],
  GOVERNMENT_IDENTIFICATION: [
    'https://assets.lili.co/onboarding/verification_center/GOVERNMENT_IDENTIFICATION.png',
  ],
  SIGNED_PARTNERSHIP_AGREEMENT: [
    'https://assets.lili.co/onboarding/verification_center/SIGNED_PARTNERSHIP_AGREEMENT.png',
  ],
};
